.row {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.chip,
.activeChip {
  background: var(--panel);
  color: var(--muted);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.4rem 1rem;
  font-size: 0.9rem;
}

.activeChip {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}
